export default __webpack_public_path__ + "static/media/Gloves of the Whispering Blade.7c46b088.jpg";